import Vue from 'vue'
import Router from 'vue-router'
import { portalState } from './state'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: 'Dashboard',
        permission: 'index:dashboard'
      },
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
      path: '/map/:imei?',
      name: 'map',
      meta: {
        title: 'Map',
        permission: 'read:map'
      },
      component: () => import(/* webpackChunkName: "map" */ './views/Map.vue')
    },
    {
      path: '/entity-status/:id',
      name: 'map',
      meta: {
        title: 'Map',
        permission: 'read:map'
      },
      component: () => import(/* webpackChunkName: "map" */ './views/DebugMap.vue')
    },
    {
      path: '/missing',
      name: 'missing',
      meta: {
        title: 'Missing',
        permission: 'manage:missing-entities'
      },
      component: () => import(/* webpackChunkName: "missing" */ './views/Missing.vue')
    },
    {
      path: '/reports',
      name: 'reports',
      meta: {
        title: 'Reports',
        permission: 'read:reports',
        roles: [
          'Manager',
          'Reporter',
          'Super Admin'
        ]
      },
      component: () => import(/* webpackChunkName: "reports" */ './views/Reports.vue')
    },
    // {
    //   path: '/maintenance-plans',
    //   name: 'maintenance-plans',
    //   meta: {
    //     title: 'Maintenance Plans',
    //     permission: 'index:maintenance-plan',
    //     roles: [
    //       'Manager',
    //       'Super Admin',
    //       'Dealer'
    //     ]
    //   },
    //   component: () => import(/* webpackChunkName: "maintenance-plans" */ './views/MaintenancePlans.vue')
    // },
    {
      path: '/notifications',
      name: 'notifications',
      meta: {
        title: 'Notifications',
        permission: 'read:information'
      },
      component: () => import(/* webpackChunkName: "notifications" */ './views/Notifications.vue')
    },
    {
      path: '/install-devices',
      name: 'install-devices',
      meta: {
        title: 'Install Devices',
        permission: 'create:entity',
        roles: [
          'Technician',
          'Manager',
          'Super Admin',
          'Dealer'
        ]
      },
      component: () => import(/* webpackChunkName: "install-devices" */ './views/InstallDevices.vue')
    },
    {
      path: '/install-devices-mobile',
      name: 'install-devices-mobile',
      meta: {
        title: 'Install Devices Mobile',
        permission: 'create:entity',
        roles: [
          'Technician',
          'Manager',
          'Super Admin',
          'Dealer'
        ]
      },
      component: () => import(/* webpackChunkName: "install-devices-mobile" */ './views/InstallDevicesMobile.vue')
    },
    {
      path: '/businesses',
      name: 'businesses',
      meta: {
        title: 'Businesses',
        permission: 'read:business-management',
        roles: [
          'Manager',
          'Super Admin'
        ]
      },
      component: () => import(/* webpackChunkName: "businesses" */ './views/Businesses.vue')
    },
    {
      path: '/users',
      name: 'users',
      meta: {
        title: 'Users',
        permission: 'read:user'
      },
      component: () => import(/* webpackChunkName: "user-management" */ './views/Users.vue')
    },
    {
      path: '/entities',
      name: 'entities',
      props: true,
      meta: {
        title: 'Entities',
        permission: 'index:entity'
      },
      component: () => import(/* webpackChunkName: "entity-management" */ './views/Entities.vue')
    },
    // {
    //   path: '/devices',
    //   name: 'devices',
    //   meta: {
    //     permission: 'read:device',
    //     title: 'Devices'
    //   },
    //   component: () => import(/* webpackChunkName: "device-management" */ './views/Devices.vue')
    // },
    // {
    //   path: '/subscriptions',
    //   name: 'subscriptions',
    //   meta: {
    //     title: 'Subscriptions',
    //     permission: 'read:subscriptions'
    //   },
    //   component: () => import(/* webpackChunkName: "payment-management" */ './views/Subscriptions.vue')
    // },
    // {
    //   path: '/subscription-management',
    //   name: 'subscription-management',
    //   meta: {
    //     title: 'Subscription Management',
    //     permission: 'create:subscriptions'
    //   },
    //   component: () => import(/* webpackChunkName: "subscription-management" */ './views/SubscriptionManagement.vue')
    // },
    {
      path: '/information',
      name: 'information',
      meta: {
        title: 'Information',
        permission: 'read:information'
      },
      component: () => import(/* webpackChunkName: "payment-management" */ './views/Information')
    },
    {
      path: '/shop',
      name: 'shop',
      meta: {
        title: 'Shop',
        permission: 'create:order'
      },
      component: () => import(/* webpackChunkName: "shop" */ './views/Shop')
    },
    {
      path: '*',
      name: 'not-found',
      meta: {
        title: 'Not found'
      },
      component: () => import(/* webpackChunkName: "token-management" */ './views/errors/NotFound.vue')
    }
  ]
})

router.beforeEach((from, to, next) => {
  const { permission } = from.meta
  const { permissions } = portalState.user
  const hasAccess = permissions.some(p => p === permission)
  if (hasAccess || from.path === '/' || permissions.length === 0) {
    next()
  } else {
    next('/')
  }
})


export default router
